import React, { ReactNode } from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'

import { DISABLED_SX_PROPS } from 'themes'

interface Props {
  children: ReactNode
  background?: boolean
  disabled?: boolean
  sx?: SxProps
}

const DisabledWrapper = (props: Props) => {
  const { background, children, disabled, sx } = props

  if (disabled)
    return (
      <Box
        sx={{
          ...DISABLED_SX_PROPS,
          ...(background ? { bgcolor: 'action.disabledBackground' } : null),
          ...sx
        }}
      >
        {children}
      </Box>
    )

  return <>{children}</>
}

export default DisabledWrapper
